export default Object.freeze({
  SMALL: 'fontSizeSmall',
  MEDIUM: 'fontSizeMedium',
  LARGE: 'fontSizeLarge',
});
